const ReviewStyles = {
  container: { p: 3,fontFamily: 'var(--font-noto-sans)' },
  title: { fontFamily: 'var(--font-noto-sans)' },
  tabBox: { borderBottom: 1, borderColor: 'divider', mb: 3 ,fontFamily: 'var(--font-noto-sans)'},
  sectionDivider: { my: 2 },
  flexWrapBox: { display: 'flex', flexWrap: 'wrap', gap: 2 },
  flexCol: { flex: '1 1 45%', minWidth: '300px' },
  confirmText: { fontFamily: 'var(--font-noto-sans)' },
  confirmBox: { mt: 3 },
  confirmLabel: { fontFamily: 'var(--font-noto-sans)' },
};

export default ReviewStyles; 